import React, { useState, useEffect } from 'react';
import { Check, X, AlertCircle } from 'lucide-react';

const ToastNotification = ({
  id,
  message,
  type = 'success',
  onClose,
  duration = 5000, // 5 seconds
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
      // Allow animation to complete before removing from DOM
      setTimeout(() => onClose(id), 300); 
    }, duration);

    return () => clearTimeout(timer);
  }, [duration, onClose, id]);

  if (!isVisible) return null;

  // Icon and text colors are white for success, with solid emerald background
  const IconComponent = type === 'success' ? Check : AlertCircle;

  return (
    <div
      className={`flex items-center gap-3 px-4 py-3 rounded-md shadow-lg border border-zinc-200 bg-white text-zinc-900
        animate-in fade-in-from-top-full duration-300 ease-out
        transition-all ease-out duration-300 min-w-[320px] max-w-[400px]
      `}
      role="alert"
    >
      <div className={`flex items-center justify-center rounded-full p-1 ${type === 'success' ? 'bg-green-600 text-white' : 'bg-red-600 text-white'}`}>
        <IconComponent className="w-4 h-4" strokeWidth={2} />
      </div>
      <div className="text-sm font-medium flex-1">
        {message}
      </div>
      <button onClick={() => setIsVisible(false)} className="ml-auto text-zinc-400 hover:text-zinc-600 p-0.5 -mt-1 -mr-1">
        <X className="w-4 h-4" />
      </button>
    </div>
  );
};

export default ToastNotification;
